import { Link } from 'react-router-dom';
import { versionList } from '@/mocks/updates';
import SectionHeading from '@/components/feature/SectionHeading';

const preview = versionList.slice(0, 3);

export default function VersionBanner() {
  return (
    <section className="mt-14 md:mt-16 rounded-lg border border-background-200 bg-background-100 p-5 md:p-8">
      <SectionHeading
        eyebrow="Version Updates"
        title="版本更新聚合"
        subtitle="回顾近期版本的核心改动与玩法调整，掌握提瓦特的最新变化"
        action={{ label: '版本记录', to: '/updates' }}
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {preview.map((version) => (
          <Link
            key={version.version}
            to="/updates"
            className="group card-hover flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 hover:border-primary-300"
          >
            <div className="relative h-40 w-full overflow-hidden">
              <img
                src={version.cover}
                alt={`原神 ${version.version} ${version.name}`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-white">
                v{version.version}
              </span>
              <span className="absolute bottom-3 left-3 font-heading text-lg font-bold text-white">
                {version.name}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <p className="text-xs text-foreground-500">上线时间 {version.date}</p>
              <p className="mt-2 flex-1 text-sm text-foreground-600 line-clamp-2">{version.summary}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                查看详情
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}